import { inject, Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import { map, Observable } from 'rxjs';

import { APOLLO_CLIENT_NAMES } from '@customer-portal/shared/constants';
import {
  apolloThrowIfNotSuccess,
  getQueryRootFieldName,
} from '@customer-portal/shared/helpers/custom-operators';

import { UpdateCommunicationLanguageResponse } from '../../dtos/communication-language.dto';
import { UPDATE_COMMUNICATION_LANGUAGE } from '../../graphql/mutations/update-communication-language.graphql';

@Injectable({ providedIn: 'root' })
export class SettingsCommunicationLanguageService {
  private clientName = APOLLO_CLIENT_NAMES.contact;

  private readonly apollo = inject(Apollo);

  updateCommunicationLanguage(communicationLanguageCode: string): Observable<{
    languageCode: string;
    isSuccess: boolean;
    message: string | undefined;
  }> {
    const fieldName =
      getQueryRootFieldName(UPDATE_COMMUNICATION_LANGUAGE) ||
      'updateCommunicationLanguage';

    return this.apollo
      .use(this.clientName)
      .mutate<UpdateCommunicationLanguageResponse>({
        mutation: UPDATE_COMMUNICATION_LANGUAGE,
        variables: { communicationLanguageCode },
      })
      .pipe(
        apolloThrowIfNotSuccess(fieldName),
        map((result) => ({
          languageCode:
            result.data?.updateCommunicationLanguage?.data
              ?.communicationLanguageCode ?? communicationLanguageCode,
          isSuccess: !!result.data?.updateCommunicationLanguage?.isSuccess,
          message: result.data?.updateCommunicationLanguage?.message || '',
        })),
      );
  }
}
